var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlybyIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#125d38",
    d: "M12,10A2,2 0 0,0 10,12C10,13.11 10.9,14 12,14C13.11,14 14,13.11 14,12A2,2 0 0,0 12,10        M12,17.5C9.76,17.5 7.78,16.45 6.63,14.7C6.08,13.8 6.08,12.63 6.63,11.73        C7.78,9.97 9.76,8.92 12,8.92C14.24,8.92 16.22,9.97 17.37,11.73        C17.92,12.63 17.92,13.8 17.37,14.7C16.22,16.45 14.24,17.5 12,17.5        M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5        C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlybyIco);
export default __webpack_public_path__ + "static/media/flyby-ico.268510fde304e5f28776cc4e78d7afdc.svg";
export { ForwardRef as ReactComponent };